import { lazy, Suspense, useEffect } from "react";
/// Components
import Index from "./jsx/router/index";
import { connect, useDispatch } from "react-redux";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import LoginTriEssense from "./jsx/pages/authentication/LoginTriEssense";
import UserLoginTriEssense from "./jsx/pages/authentication/UserLoginTriEssense";
// action
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
//Style
import "rsuite/dist/rsuite-no-reset.min.css";
import "./assets/css/style.css";
import Home from "./jsx/pages/dashboard/Home";
import LoginRestaurant from "./jsx/pages/authentication/LoginRestaurant";
import "./assets/css/LoginTriEssense.css";
import AdminVerificationTE from "./jsx/pages/authentication/AdminVerificationTE";
import UserVerificationTE from "./jsx/pages/authentication/UserVerificationTE";
import CACard from "./jsx/pages/CACard/CACard";
import EditUserProfile from "./jsx/pages/Profile/EditUserProfile";
import StaffLoginTriEssense from "./jsx/pages/authentication/StaffLoginTriEssense";
import AdminForgotPasswordTE from "./jsx/pages/authentication/adminForgotpassword/AdminForgotPasswordTE";
import UserForgotPasswordVerifyOtp from "./jsx/pages/authentication/userforgotpassword/UserFPVerifyOtp";
import UserChangePasswordSection from "./jsx/pages/authentication/userforgotpassword/UserChangePasswordSection";
import UserForgotPassword from "./jsx/pages/authentication/userforgotpassword/UserForgotPasswordTE";
import AdminFPVerifyOtp from "./jsx/pages/authentication/adminForgotpassword/AdminFPVerifyOtp";
import AdminChangePasswordSection from "./jsx/pages/authentication/adminForgotpassword/AdminChangePasswordSection";


const SignUp = lazy(() => import("./jsx/pages/authentication/Registration"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/authentication/Login")), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON?.parse(localStorage?.getItem('user'))

  useEffect(() => {
    // if (!/.*\/user\/card\/\d+/.test(location?.pathname)) {
    //   checkAutoLogin(dispatch, navigate);
    // }

    //  if (!/.*\/user\/card\/(?:\d+|[a-zA-Z]+)/.test(location?.pathname)) {
    //    checkAutoLogin(dispatch, navigate);
    //  }  

     if (!/.*\/user\/(?:\d+|[a-zA-Z]+)/.test(location?.pathname)) {
      checkAutoLogin(dispatch, navigate);
      }  
  }, []);

  // console.log(props.isAuthenticated,"props.isAuthenticated");
  let routeblog = (
    <Routes>
      <Route path="/login" element={<LoginTriEssense />} />
      <Route path="/verification" element={<AdminVerificationTE />} />
      <Route path="/user/login" element={<UserLoginTriEssense />} />
       
       {/* admin forgot password */}
      <Route path="/forgotpassword" element={<AdminForgotPasswordTE />} />
      <Route path="/otp-varification" element={<AdminFPVerifyOtp />} />
      <Route path="/change-password" element={<AdminChangePasswordSection />} />
       
       {/* user forgot password */}
      <Route path="/user/forgotpassword" element={<UserForgotPassword/>} />
      <Route path="/user-otp-verification" element={<UserForgotPasswordVerifyOtp />} />
      <Route path="/user-change-password" element={<UserChangePasswordSection />} />
      

      <Route path="/user/verification" element={<UserVerificationTE />} />
      <Route path="/user/:id" element={<CACard />} />

      <Route path="/staff/login" element={<StaffLoginTriEssense />} />
      
      <Route path="/login/res" element={<LoginRestaurant />} />
      <Route path="/page-register" element={<SignUp />} />
      <Route path="edit-user-profile/:id" element={<EditUserProfile/>} />
    </Routes>
  );
 
  let routeblog2 = (
    <Routes>
      <Route path="/user/:id" element={<CACard />} />
      {/* <Route path="/user/card" element={<UserProfile/>}/> */}
    </Routes>
  )
// console.log("props.isAuthenticated",props.isAuthenticated)
  if (props.isAuthenticated) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }>
        {/* {
          /.*\/user\/card\/\d+/.test(location.pathname) ? routeblog2 :
          <Index />
        } */}
         
        {
          /.*\/user\/(?:\d+|[a-zA-Z]+)/.test(location.pathname) ? routeblog2 :
          <Index />
        }
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100" style={{overflow:"hidden"}}>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }>
          {routeblog}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));
